import React from "react";
import Head from "next/head";

interface SeoProps {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
  type?: string;
  keywords?: string;
  robots?: string;
  author?: string;
  twitter?: string;
  twitterCard?: string;
  twitterSite?: string;
  twitterCreator?: string;
  twitterTitle?: string;
  twitterDescription?: string;
  twitterImage?: string;
  twitterImageAlt?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
  ogImageAlt?: string;
  ogUrl?: string;
  ogSiteName?: string;
  ogLocale?: string;
  ogType?: string;
  fbAppId?: string;
  fbAdmins?: string;
}
const Seo = ({ title, description, image, author }: SeoProps) => {
  return (
    <Head>
      <title>{`${title} • Brimble`}</title>
      <meta name="description" content={description} />
      <meta name="image" content={image} />
      <meta name="robots" content="index, follow" />
      <meta name="author" content={author} />
    </Head>
  );
};

export default Seo;
